import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import _ from "underscore";
import { useIntersection } from "../../Hooks/customHooks";
import { START_PHARMACY_LIST } from "../../Actions/PatientAction";
import { CircularProgress, Grid, TextField, Button } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import "../../Sass/Common.scss";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  PharmacyAutocompleteListbox: {
    padding: "0px !important",
    // marginTop: "45px !important"
  },
  addButton: {
    "&>button": {
      fontSize: "1rem",
      overflow: "hidden",
      [theme.breakpoints.between("1600", "1700")]: {
        fontSize: "0.9rem",
      },
      [theme.breakpoints.between("1500", "1600")]: {
        fontSize: "0.85rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
      },
      [theme.breakpoints.between("1400", "1500")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        // height:"40px"
      },
      [theme.breakpoints.between("1300", "1400")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "38px",
      },
      [theme.breakpoints.between("1200", "1300")]: {
        fontSize: "0.8rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
        height: "38px",
      },
      [theme.breakpoints.between("1100", "1200")]: {
        fontSize: "0.7rem",
        paddingLeft: "13px !important",
        paddingTop: "0px !important",
        paddingBottom: "0px !important",
      },
    },
  },
}));

function ImportCsv(props) {
  const {
    value,
    multiple,
    disabled,
    handleChange,
    pharmacyList,
    getPharmacyListAction,
    apiParams,
    disableEnter = true,
    maxValue,
    driverListFlag,
    helperText,
    error = false,
    selecttedSurgry,
    maxVisibleChip = 2,
    values,
    isOpenPharmacyAutocomplete,
    setIsOpenPharmacyAutocomplete,
    buttonOptionTop,
    buttonTitle,
    handleButtonClick,
    textFieldProps = {
      required: true,
    },
    ...other
  } = props;
  const classes = useStyles();
  const [selectPharmacy, setSelectPharmacy] = useState(value || {});
  const [pharmacySearchString, setPharmacySearchString] = useState("");
  const [isOpenPharmacyList, setIsOpenPharmacyList] = useState(false);
  const [setTargetPharmacy, entryPharmacy] = useIntersection({
    threshold: 0.1,
  });
  const query = new URLSearchParams(window.location.search);
  /** get value data */
  useEffect(() => {
    if (multiple) {
      setSelectPharmacy(Object.values(value || {}));
    } else {
      setSelectPharmacy(value);
    }
  }, [value]);

  /** Focus open list useEffect */
  useEffect(() => {
    if (query.get("actionType") === "create") {
      if (isOpenPharmacyAutocomplete) {
        setIsOpenPharmacyList(true);
        setIsOpenPharmacyAutocomplete(false);
      }
    }
  }, [isOpenPharmacyAutocomplete]);
  /** get list on entry  */
  useEffect(() => {
    if (entryPharmacy.isIntersecting && pharmacyList.loading === false) {
      let params = {
        offset: pharmacyList?.data?.list?.length || 0,

        ...(pharmacySearchString && { q: pharmacySearchString }),
      };
      if (isOpenPharmacyList) {
        getPharmacyListAction(params);
      }
    }
  }, [entryPharmacy]);

  /** handle search pharmacy */
  const searchPharmacyDebounce = useRef(
    _.debounce((searchString, open) => {
      let params = {
        offset: 0,
      };
      if (searchString) {
        params.q = searchString;
      }
      if (open) {
        getPharmacyListAction(params);
      }
    }, 500)
  );

  /** handle search pharmacy */
  const handleSearchPharmacy = (newValue) => {
    setPharmacySearchString(newValue);
    searchPharmacyDebounce.current(newValue, isOpenPharmacyList);
  };

  /** handle fetch pharmacy */
  let fetchPharmacy = () => {
    setIsOpenPharmacyList(true);
    let params = {
      offset: 0,
      ...(pharmacySearchString && { q: pharmacySearchString }),
    };
    getPharmacyListAction(params);
  };

  /** handle change pharmcy list */
  const handleChangePharmacyList = (event, newValue) => {
    let newList = {};
    if (multiple) {
      newValue.map((pharmacy) => {
        newList[pharmacy.id] = pharmacy;
      });
    } else {
      newList = newValue;
    }
    setSelectPharmacy(newValue);
    handleChange && handleChange(newList);
  };

  /** Filter options with a custom button at the top of the list */
  const filterOptions = (options) => {
    let result = [...options];
    if (buttonOptionTop && !result.some((option) => option.type === "button")) {
      result = [{ type: "button" }, ...result];
    }
    if (pharmacyList?.data?.list?.length < pharmacyList?.data?.total) {
      if (!result.some((option) => option === "FinalOption")) {
        result.push("FinalOption");
      }
    }
    return result;
  };

  return (
    <>
      <Autocomplete
        multiple={multiple}
        id="temptemp"
        classes={{
          listbox: classes.PharmacyAutocompleteListbox,
          option: "option",
        }}
        disableCloseOnSelect={multiple}
        disabled={Boolean(disabled)}
        onOpen={fetchPharmacy}
        open={isOpenPharmacyList}
        onClose={() => {
          setIsOpenPharmacyList(false);
        }}
        loading={pharmacyList?.loading}
        noOptionsText={"No results found"}
        value={selectPharmacy}
        onChange={handleChangePharmacyList}
        options={pharmacyList?.data?.list || []}
        getOptionLabel={(option) => {
          return option.name || "";
        }}
        isOptionEqualToValue={(option, value) => {
          return option?.id === value?.id;
        }}
        onInputChange={(event, newValue) => {
          handleSearchPharmacy(newValue);
        }}
        filterOptions={filterOptions}
        renderOption={(props, option, { selected }) => {
          if (buttonOptionTop && option.type === "button") {
            return (
              <Grid
                container
                alignItems="center"
                className={clsx("autoCompleteButton", classes.addButton)}
              >
                <Button
                  onClick={handleButtonClick}
                  fullWidth
                  variant="contained"
                  color="primary"
                >
                  {buttonTitle}
                </Button>
              </Grid>
            );
          } else {
            return (
              <React.Fragment>
                {typeof option === "object" ? (
                  <Grid {...props} key={option?.id}>
                    {option.name}
                  </Grid>
                ) : (
                  <Grid
                    className="autoCompleteInputLoader"
                    ref={setTargetPharmacy}
                  >
                    <CircularProgress size={20} />
                  </Grid>
                )}
              </React.Fragment>
            );
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            error={error}
            helperText={helperText}
            InputLabelProps={{ required: false }}
            inputProps={{
              ...params.inputProps,
              autoComplete: "new-password",
              endAdornment: (
                <React.Fragment>
                  {pharmacyList?.loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        {...other}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  pharmacyList: state.patient.pharmacyList,
});

const mapDispatchToProps = (dispatch) => ({
  getPharmacyListAction: (payload) =>
    dispatch({ type: START_PHARMACY_LIST, payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportCsv);
